import { useCallback } from 'react';

import { useUserAgent } from '@/context/UserAgent';
import { useSnackbar } from '@/features/snackbar';

function useCopyUrlToClipboard() {
  const { addSnackbar } = useSnackbar();
  const { isMobile, isTablet } = useUserAgent();
  const copyFn = useCallback(async () => {
    const device =
      RUNTIME_ENV === 'native'
        ? 'native'
        : isMobile || isTablet
        ? 'mobile'
        : 'web';
    const url = `https://simplywall.st${window.location.pathname}`;
    const urlWithParams = `${url}?utm_source=share&utm_medium=${device}`;

    addSnackbar({
      message: 'Link copied',
      type: 'positive',
      lifeTime: 3000,
    });

    try {
      return await navigator.clipboard.writeText(urlWithParams);
    } catch (error) {
      return;
    }
  }, [addSnackbar, isTablet, isMobile]);

  return copyFn;
}
export default useCopyUrlToClipboard;
